import { Box, Stack, Typography } from "@mui/material"
import useTranslation from "hooks/use_translation"

const ProgressBar = (props) => {
  const { currentStep, steps } = props
  const title = steps[currentStep]
  const { anamnesis } = useTranslation()

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="caption" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="caption">
          {anamnesis?.step_first} {currentStep + 1} {anamnesis?.step_second} {steps.length}
        </Typography>
      </Box>
      <Stack direction="row" sx={{ mx: -0.5 }}>
        {steps.map((_step, i) => (
          <Box
            key={i}
            sx={{
              flexGrow: currentStep === i ? 2 : 1,
              mx: 0.5,
              backgroundColor: currentStep >= i ? "primary.main" : "#E0E6EF",
              height: 6,
              borderRadius: 3,
            }}
          />
        ))}
      </Stack>

      <Box></Box>
    </Box>
  )
}

export default ProgressBar
